//Search
export const TESTING_EQUIPMENT_SEARCH_START_LOADING = "TESTING_EQUIPMENT_SEARCH_START_LOADING";
export const TESTING_EQUIPMENT_SEARCH_END_LOADING = "TESTING_EQUIPMENT_SEARCH_END_LOADING";
export const TESTING_EQUIPMENT_SEARCH_LOADED = "TESTING_EQUIPMENT_SEARCH_LOADED";
export const SET_TESTING_EQUIPMENT_FILTER = "SET_TESTING_EQUIPMENT_FILTER";

//Edit
export const TESTING_EQUIPMENT_START_LOADING = "TESTING_EQUIPMENT_START_LOADING";
export const TESTING_EQUIPMENT_END_LOADING = "TESTING_EQUIPMENT_END_LOADING";
export const TESTING_EQUIPMENT_LOADED = "TESTING_EQUIPMENT_LOADED";
